//views
import homePageReducer from './components/landing/HomepageNew/reducer';
import creationComponentReducer from './components/landing/Product/CreationComponent/reducer';
import productReducer from './components/landing/Product/reducer';
import CashComponentReducer from './components/landing/Product/CashComponent/reducer';
import modalReducer from './components/general/Modal/reducer';
import careerReducer from './components/landing/Careers/reducer';
import informationReducer from './components/landing/Information/reducer';
import navDividendReducer from './components/landing/NavDividend/reducer';
import contactUsReducer from './components/landing/ContactUs/reducer';
import StaticPageReducer from './components/landing/PrivacyPolicy/reducer';
import sitemapReducer from './components/landing/Sitemap/reducer';
import cookiePolicyReducer from './components/landing/CookiePolicy/reducer';
import SubscribeReducer from './components/landing/SubscribeValidate/reducer';
import RemoveSubscribeReducer from './components/landing/RemoveSubscribeValidate/reducer';
import whatsAppService from "./components/landing/WhatsappJourney/reducer";
import sipInputValue from "./components/landing/Home/CalulcatorSection/action";
//container

import {ACTION, LANGUAGE} from '../constants';
import unclaimedDataReducer from "./components/landing/StatutoryDisclosure/UnclaimedDividendRedemptionNew/action";
import modalsStickBar from './components/general/Modals/reducer';
import AboutNewReducer from './components/landing/AboutUs/reducer';
import AccountStatementReducer from "./components/landing/AccountStatement/reducer";
import SipLandingReducer from "./components/landing/Learn/Sip/reducer";
import LearnsCornersReducer from './components/landing/LearnersCorner/reducer';

import ProductSolutionReducer from './components/landing/ProductSolutions/reducer';
import mfBytesReducer from './components/landing/MfBytes/reducer';
import StatutoryDisclosuresReducer from './components/landing/StatutoryDisclosure/reducer';
import statutoryinformationReducer from './components/landing/StatutoryInformation/reducer';
import BeginnerInformationReducer from './components/landing/BeginnerInformation/reducer'
import IntermediateInformationReducer from './components/landing/IntermediateInformation/reducer'
import AdvanceInformationReducer from './components/landing/AadvancedInformation/reducer';
import DistributorCornerReducer from './components/landing/DistributorCorner/reducer';
import distributorinformationReducer from './components/landing/DistributorCornerInformation/reducer';
import InvesterServicesReducer from './components/landing/InvestorServices/reducer';
import investorinformationReducer from './components/landing/InvestorServicesInformation/reducer';
import BookreviewInformationReducer from './components/landing/BookreviewInformation/reducer'
//knowledge stack start
import MdspeakarticleInformationReducer from './components/landing/MdSpeakArticleInformation/reducer.js';
import TalkingInformationReducer from './components/landing/TalkingpointInformartion/reducer';
import WeekendInformationReducer from './components/landing/WeekendbytesInformartion/reducer';
import MonthlyInformationReducer from './components/landing/MonthlyMusingInformartion/reducer';
import CreditPolicyInformationReducer from './components/landing/CreditPolicyInformartion/reducer.js';
import KnowledgeStackReducer from './components/landing/KnowledgeStack/reducer';
import BehaviouralInformationReducer from './components/landing/BehaviouralBlogInformartion/reducer.js'
import MarketReviewInformationReducer from './components/landing/MarketReviewInformation/reducer.js';
//knowledge stack end
import eCartReducer from './components/general/Modal/ECartModal/reducer';
import AuthenticationReducer from './components/general/Modal/Authentication/reducer';
import goalMarketingReducer from './components/landing/GoalMarketing/reducer.js';
import IapLandingReducer from './components/landing/IAPPage/reducer.js';
import GlossaryReducer from './components/landing/Glossary/reducer.js';
import IAPWomenReducer from './components/landing/IAPWomen/reducer.js';
import SurveyReducer from './components/landing/Survey/reducer.js';
import JanNiveshReducer from './components/landing/JanNivesh/reducer.js';

// const language = (state = {currentSelected: LANGUAGE.EN}, action) => {
//     switch (action.type) {
//         case ACTION.GET_LANG_SUCCESS :
//             return {...state,  currentSelected: action.data};
//         default:
//             return state;
//     }
// };
let initialState= {
    menu:{},
    currentSelected: LANGUAGE.EN,
    isLoading: false,
    metaData:{
        title:'',
        description:'',
        keywords: '',
        ogTitle:'',
        ogDescription:'',
        // investment Fund Schema
        category:'',
        fundDescription:'',
        fundTitle:'',
        // for article schema
        headline:'',
        articleBody:'',
        articleSection:'',
        imageUrl:'',
        datePublished:'',
        dateModified:'',
        wordCount:'',
        articleDesc:''

    }
};
const commonContent = (state = initialState, action) => {
    switch (action.type) {
        case ACTION.GET_MENU_SUCCESS :
            return {...state, menu: action.data};
        case ACTION.GET_LANG_SUCCESS :
            return {...state, currentSelected:action.data};
        case ACTION.SHOW_MAIN_LOADER :
            return {...state,  isLoading: true};
        case ACTION.HIDE_MAIN_LOADER :
            return {...state,  isLoading: false};
        case ACTION.ADD_META_DATA :
            return {...state,  metaData: action.data}
        case "SAVE_BREADCRUMB" :
            return {...state, metaData: {...state.metaData, breadcrumbList: action.data}}
        case ACTION.SAVE_CART_DETAILS:
            return { ...state, cartCount: action.data };
        case ACTION.GET_PROMOTIONAL_HEADER:
            return { ...state, promotionHeader: action.data };
        default:
            return state;
    }
};

export default {
    modal : modalReducer,
    commonContent: commonContent,
    product:productReducer,
    creationComponent:creationComponentReducer,
    cashComponent:CashComponentReducer,
    career: careerReducer,
    informationDetail: informationReducer,
    navDividend:navDividendReducer,
    contactUs:contactUsReducer,
    staticPages:StaticPageReducer,
    sitemap: sitemapReducer,
    cookiePolicy: cookiePolicyReducer,
    subscribe : SubscribeReducer,
    removeSubscribe : RemoveSubscribeReducer,
    whatsAppService: whatsAppService,
    sipInputValue: sipInputValue,
    unclaimedData: unclaimedDataReducer,
    stickBar: modalsStickBar,
    aboutnew: AboutNewReducer,
    homePage: homePageReducer,
    acccountStatement: AccountStatementReducer,
    sipLanding: SipLandingReducer,
    LearnsCorners: LearnsCornersReducer,
    ProductSolution: ProductSolutionReducer,
    mfBytes:mfBytesReducer,
    StatutoryDisclosures: StatutoryDisclosuresReducer,
    statutoryInformation: statutoryinformationReducer,
    beginnerInformation: BeginnerInformationReducer,
    intermediateInformation: IntermediateInformationReducer,
    AdvanceInformation : AdvanceInformationReducer,
    DistributorCorner: DistributorCornerReducer,
    distributorInformation: distributorinformationReducer,
    InvesterServices: InvesterServicesReducer,
    investorInformation : investorinformationReducer,
    BookreviewInformation : BookreviewInformationReducer,
    KnowledgeStack: KnowledgeStackReducer,
    mdSpeakArticleInformation: MdspeakarticleInformationReducer,
    talkingInformation : TalkingInformationReducer,
    weekendInformation: WeekendInformationReducer,
    MonthlyInformation: MonthlyInformationReducer,
    CreditPolicyInformation : CreditPolicyInformationReducer,
    BehaviouralInformation : BehaviouralInformationReducer,
    MarketReviewInfoDetail : MarketReviewInformationReducer,
    eCart: eCartReducer,
    authentication: AuthenticationReducer,
    goalMarketing: goalMarketingReducer,
    iappage: IapLandingReducer,
    glossary:GlossaryReducer,
    iapWomen: IAPWomenReducer,
    survey: SurveyReducer,
    janNivesh: JanNiveshReducer,
};
